if (!customElements.get('video-explainer')) {
  customElements.define(
    'video-explainer',
    class VideoExplainer extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        const signal = this.abortController.signal;

        this.card = this.querySelector('.video-explainer__card');
        this.toggleButtons = Array.from(this.querySelectorAll('[data-version-toggle]'));
        this.panels = Array.from(this.querySelectorAll('[data-version-panel]'));

        this.toggleButtons.forEach((button) => {
          button.addEventListener('click', () => this.setActiveVersion(button.dataset.versionToggle), {
            signal,
          });
        });

        if (this.card) {
          this.card.addEventListener(
            'click',
            (event) => {
              if (event.target.closest('.video-explainer__toggle')) return;
              this.openActiveModal();
            },
            { signal }
          );
        }

        this.bindModals(signal);

        const initial = this.dataset.activeVersion || this.panels[0]?.dataset.versionPanel;
        if (initial) this.setActiveVersion(initial);
      }

      disconnectedCallback() {
        this.abortController.abort();
      }

      get autoplay() {
        return this.hasAttribute('data-autoplay');
      }

      get activePanel() {
        return this.panels.find((panel) => !panel.hidden);
      }

      modalFor(panel) {
        return panel && panel.dataset.modal ? document.getElementById(panel.dataset.modal) : null;
      }

      bindModals(signal) {
        this.panels.forEach((panel) => {
          const modal = this.modalFor(panel);
          const video = modal && modal.querySelector('video-element');
          if (!video) return;

          modal.addEventListener(
            'modal:handleAfterShow',
            () => {
              if (this.autoplay) video.play();
            },
            { signal }
          );

          modal.addEventListener('modal:handleAfterHide', () => video.pause(), { signal });
        });
      }

      openActiveModal() {
        const panel = this.activePanel;
        const modal = this.modalFor(panel);
        if (!modal) return;

        const trigger = panel.querySelector('.video-explainer__trigger');

        if (typeof modal.show === 'function') {
          modal.show(trigger);
        } else {
          // The modal element has not been upgraded yet; the attribute is picked up on upgrade.
          modal.setAttribute('open', '');
        }
      }

      setActiveVersion(version) {
        this.panels.forEach((panel) => {
          panel.hidden = panel.dataset.versionPanel !== version;
        });

        this.toggleButtons.forEach((button) => {
          const isActive = button.dataset.versionToggle === version;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive);
        });

        this.dataset.activeVersion = version;

        if (this.card) {
          this.card.classList.toggle('video-explainer__card--static', !this.modalFor(this.activePanel));
        }
      }
    }
  );
}
